export default ({ data }) => {
  const { payload } = data;

  delete payload.webchatKey;
  const message = JSON.stringify(payload);

  if (window.webbotConnection) {
    window.webbotConnection.send(message);
  }
};
